import logo from "../assets/logo.png";

export default function AuthCard({ title, subtitle, headerAction, children }) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-brand-bg px-4 py-10">
      <div className="relative w-full max-w-md bg-brand-card rounded-[30px] shadow-[0_0_2em_#e6e9f9] px-8 py-10 sm:px-10 sm:py-12 flex flex-col gap-8">
        {headerAction && <div className="absolute top-5 right-5 sm:top-6 sm:right-6">{headerAction}</div>}

        <div className="flex flex-col items-center gap-3 text-center">
          <img src={logo} alt="Colombo Dockyard" className="w-32 sm:w-36 drop-shadow-sm" />
          {title && (
            <h1 className="text-xl sm:text-2xl font-semibold text-brand-navy">{title}</h1>
          )}
          {subtitle && <p className="text-sm text-brand-muted">{subtitle}</p>}
        </div>

        {children}
      </div>
    </div>
  );
}
